module.exports = __webpack_public_path__ + "static/media/hiclipart.d4349aa4.png";